export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-orange-500 to-orange-600 text-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Logo and Description */}
          <div>
            <img 
              src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/f87325baca69aa8ba2d9715825ce3361.png" 
              alt="Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              Campeonato Brasileiro de Ginetta G55 Supercup 2026 - A competição mais organizada e competitiva da categoria GT4 no simracing brasileiro.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="#features" className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer">
                  Gallery
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-whatsapp-line text-xl mr-3 mt-0.5"></i>
                <a 
                  href="https://chat.whatsapp.com/B8pgKs2dDmD57QLiP896ds"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Grupo Oficial WhatsApp
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-youtube-line text-xl mr-3 mt-0.5"></i>
                <a 
                  href="https://www.youtube.com/@italentvseries"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  YouTube iTalent V-Series
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-file-text-line text-xl mr-3 mt-0.5"></i>
                <a 
                  href="https://forms.gle/tTc5BatSeyfwnPFJ8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Formulário de Inscrição
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/80 text-center sm:text-left">
            © 2026 Ginetta G55 Supercup. Todos os direitos reservados.
          </p>
          <a 
            href="https://italentagency.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
          >
            Powered by iTalent Agency
          </a>
        </div>
      </div>
    </footer>
  );
}
